<div class="container-fluid p-0" [formGroup]="form">
    <!-- Toggle Bogotá / fuera de Bogotá -->
    <fieldset class="mb-3">
        <legend class="form-label h6 mb-2">¿La ubicación es en Bogotá? <span class="text-danger">*</span></legend>
        <div class="d-flex flex-wrap gap-2">
            <div class="form-check form-check-inline m-0">
                <input class="form-check-input" type="radio" formControlName="es_bogota" id="es_bogota_si" [value]="true" />
                <label class="form-check-label" for="es_bogota_si">Sí</label>
            </div>
            <div class="form-check form-check-inline m-0">
                <input class="form-check-input" type="radio" formControlName="es_bogota" id="es_bogota_no" [value]="false" />
                <label class="form-check-label" for="es_bogota_no">No</label>
            </div>
        </div>
    </fieldset>

    <!-- BOGOTÁ (mapa) -->
    <div [hidden]="form.get('es_bogota')?.value !== true">
        <p>Ubica el icono en el mapa, activa la ubicación en su navegador o escribe la dirección para obtener su ubicación (Aplica solo para Bogotá)</p>
        <div class="row g-2 mb-4">
            <label id="direccion_label" class="visually-hidden"> Dirección aproximada </label>
            <div class="col-md-10">
                <input type="text" aria-labelledby="direccion_label" id="direccion_aproximada" formControlName="direccion_aproximada" class="form-control" placeholder="Escribe una dirección..." />
                <small class="form-text text-muted mt-1 d-block"><i class="fas fa-info-circle me-1" aria-hidden="true"></i>Ingrese la dirección utilizando la nomenclatura oficial. Ejemplo: <strong>Carrera 71D # 6-94 Sur</strong>.</small>
            </div>
            <div class="col-md-1">
                <button type="button" aria-label="Buscar dirección" class="btn btn-primary w-100" (click)="searchByAddress()" id="basic-addon2"><i class="fas fa-search"></i></button>
            </div>
        </div>
        <div class="mb-2">
            <button type="button" class="btn btn-primary btn-sm" (click)="usarMiUbicacion()">
                <i class="fas fa-location-crosshairs"></i>
                Usar mi ubicación
            </button>
        </div>
        <div role="application" [id]="mapId" style="width: 100%; height: 500px"></div>
    </div>

    <!-- FUERA DE BOGOTÁ (nomenclatura catastral) -->
    <div class="direccion-catastral" [hidden]="form.get('es_bogota')?.value !== false">
        <div class="alert alert-warning d-flex align-items-center gap-3 proximamente-banner" role="alert">
            <i class="fas fa-tools fa-2x" aria-hidden="true"></i>
            <div>
                <strong class="d-block fs-5">¡Próximamente!</strong>
                <span>Estamos trabajando en el registro de direcciones fuera de Bogotá. Muy pronto podrás diligenciar esta sección.</span>
            </div>
        </div>

        <!--<p>
            Ingrese la dirección según la nomenclatura catastral. Ejemplo: <b>{{ direccionNacional }}</b>
        </p>

        <div class="row mb-3">
            <div class="col">
                <label class="form-label" for="municipio">Departamento - municipio</label>
                <ng-select formControlName="municipio" id="municipio" [items]="municipios" bindLabel="nombre" bindValue="id" placeholder="Seleccione"> </ng-select>
            </div>
        </div>

        <div class="row mb-0 mb-lg-3">
            <div class="col">
                <label class="form-label" for="via">Vía</label>
                <ng-select formControlName="via" id="via" [items]="tiposVia" bindLabel="nombre" bindValue="nombre" placeholder="Seleccione"> </ng-select>
            </div>
            <div class="col">
                <label class="form-label" for="numero_via_principal">Número</label>
                <input type="text" formControlName="numero_via_principal" id="numero_via_principal" class="form-control" />
            </div>
            <div class="col col-letra">
                <label class="form-label" for="letra_via_principal">Letra</label>
                <ng-select formControlName="letra_via_principal" id="letra_via_principal" [items]="letras" placeholder="Seleccione"> </ng-select>
            </div>
            <div class="col col-bis">
                <div class="form-check mt-4 pt-2">
                    <input class="form-check-input" type="checkbox" formControlName="bis" id="bis" />
                    <label class="form-check-label" for="bis">Bis</label>
                </div>
            </div>
            <div class="col">
                <label class="form-label" for="cuadrante_via">Sector / sentido</label>
                <ng-select formControlName="cuadrante_via" id="cuadrante_via" [items]="referenciaCardinal" placeholder="Seleccione"> </ng-select>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col">
                <label class="form-label" for="numero_via_generadora">Vía generadora</label>
                <input formControlName="numero_via_generadora" id="numero_via_generadora" type="text" class="form-control" />
            </div>
            <div class="col">
                <label class="form-label" for="letra_via_generadora">Letra</label>
                <ng-select formControlName="letra_via_generadora" id="letra_via_generadora" [items]="letras" placeholder="Seleccione"> </ng-select>
            </div>
            <div class="col">
                <label class="form-label" for="numero_placa">Número del predio</label>
                <input formControlName="numero_placa" id="numero_placa" type="text" class="form-control" />
            </div>
            <div class="col">
                <label class="form-label" for="cuadrante_placa">Sector / sentido</label>
                <ng-select formControlName="cuadrante_placa" id="cuadrante_placa" [items]="referenciaCardinal" placeholder="Seleccione"> </ng-select>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col">
                <label class="form-label" for="informacion_complementaria">Información complementaria (torre, apto, interior, etc.)</label>
                <input formControlName="informacion_complementaria" id="informacion_complementaria" type="text" class="form-control" placeholder="Opcional" />
            </div>
        </div>-->
    </div>
</div>
